<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 430 430"
  >
    <path
      :fill="iconColor"
      d="M398.4 0H31.8A31.3 31.3 0 0 0 0 30.8v368.5c0 17 14.2 30.8 31.8 30.8h366.6a31.3 31.3 0 0 0 31.7-30.8V30.8c0-17-14.2-30.8-31.7-30.8zm-268 360h-65V165.8h65V360zM97.9 139.3h-.4c-21.8 0-36-14.9-36-33.5 0-19 14.6-33.6 36.8-33.6 22.3 0 36 14.5 36.4 33.6 0 18.6-14.1 33.5-36.8 33.5zM364.7 360h-65V256.1c0-26-9.4-43.9-33-43.9-17.9 0-28.6 12-33.2 23.6-1.8 4.2-2.2 10-2.2 15.8V360h-65s.9-176 0-194.2h65v27.6a64.5 64.5 0 0 1 58.5-32.1c42.8 0 74.9 27.7 74.9 87.4V360zM230.9 194c0-.2.2-.4.4-.6v.6h-.4z"
    />
  </svg>
</template>

<script>
export default {
  name: "LinkedInIcon",
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>

<style scoped></style>
